import { ShieldAlert, Sparkles } from "lucide-react";
import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { cn } from "./ui";

export const RISK_CLS: Record<string, string> = { Rendah: "bg-emerald-100 text-emerald-800 dark:bg-emerald-950/50 dark:text-emerald-200", Sedang: "bg-amber-100 text-amber-800 dark:bg-amber-950/50 dark:text-amber-200", Tinggi: "bg-red-100 text-red-800 dark:bg-red-950/50 dark:text-red-200" };

export function RiskBadge({ r, testId }: { r?: { level: string; score: number }; testId?: string }) {
  if (!r) return <span className="text-xs text-muted-foreground">-</span>;
  return <span data-testid={testId} className={cn("inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-bold", RISK_CLS[r.level])} title={`Skor ${r.score}/100`}>{r.level} · {r.score}</span>;
}

export function RiskCard({ loanId }: { loanId: string }) {
  const [r, setR] = useState<any>(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get(`/ai/risk/${loanId}`).then((x) => setR(x.data)).catch(() => setR(null)); }, [loanId]);
  const explain = async () => { setBusy(true); try { const { data } = await api.get(`/ai/risk/${loanId}`, { params: { explain: true } }); setR(data); } finally { setBusy(false); } };
  if (!r) return null;
  return (
    <div className="rounded-xl border p-4 space-y-2" data-testid="risk-card">
      <div className="flex items-center justify-between gap-2">
        <p className="text-sm font-semibold inline-flex items-center gap-1.5"><ShieldAlert className="h-4 w-4" /> Risiko Gagal Bayar</p>
        <RiskBadge r={r} testId="risk-badge" />
      </div>
      <p className="text-xs text-muted-foreground num">Telat {r.days_late} hr · Col {r.col} · {r.late_ratio}% cicilan dibayar terlambat (rata-rata {r.avg_late_days} hr) · {r.partial_count} bayar sebagian · {r.void_count} void · lunas {r.paid_installments}/{r.total_installments}</p>
      {r.explanation ? <p className="text-sm leading-relaxed" data-testid="risk-explanation">{r.explanation}</p>
        : <button type="button" className="text-xs font-semibold text-primary inline-flex items-center gap-1" disabled={busy} onClick={explain} data-testid="risk-explain-button"><Sparkles className="h-3 w-3" /> {busy ? "Menganalisis…" : "Penjelasan AI"}</button>}
    </div>
  );
}
